import colors from "@constants/colors"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: inline-flex;
  position: absolute;
  transform: translateX(17px) translateY(-8px);
  min-width: 14px;
  height: 14px;
  padding: 2px 3px 0 3px;
  align-items: center;
  justify-content: center;
  font-family: "Interstate Regular";
  font-size: 9px;
  color: ${colors.white};
  text-transform: uppercase;
  background-color: ${colors.brandOrange};
  border-radius: 50% 50% 50% 0;
  &.hidden {
    display: none;
  }
`

export interface CountBubbleProps {
  count: number
}

const CountBubble: React.FC<CountBubbleProps> = ({
  count,
}: CountBubbleProps) => {
  return <Container className={count ? "" : "hidden"}>{count}</Container>
}

export default CountBubble
